
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-it-works/statistics",
      function () {
        return require("private-next-pages/how-it-works/statistics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-it-works/statistics"])
      });
    }
  